var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19093 2.08011C6.87785 0.797369 8.21584 -0.0023503 9.67093 0.000113029C11.1518 -0.0109921 12.5176 0.796944 13.2209 2.10011L18.8609 12.5401C19.53 13.7797 19.4978 15.2798 18.7761 16.4895C18.0544 17.6992 16.7496 18.4401 15.3409 18.4401H4.00093C2.58808 18.4404 1.27986 17.6954 0.559307 16.4801C-0.161247 15.2648 -0.187239 13.7596 0.490927 12.5201L6.19093 2.08011ZM11.8707 2.81016C11.4369 1.99942 10.5902 1.49522 9.67068 1.50016C8.76471 1.50644 7.93365 2.00431 7.50068 2.80016L1.81068 13.2202C1.38569 13.9928 1.40109 14.9327 1.85116 15.691C2.30124 16.4494 3.11885 16.9131 4.00068 16.9102H15.3407C16.2194 16.9048 17.0313 16.4403 17.4813 15.6856C17.9313 14.9308 17.9538 13.9957 17.5407 13.2202L11.8707 2.81016Z",
    fill: "#FFA500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6709 12.0002C9.25668 12.0002 8.9209 12.336 8.9209 12.7502C8.9209 13.1645 9.25668 13.5002 9.6709 13.5002C9.87063 13.503 10.063 13.4248 10.2042 13.2836C10.3455 13.1423 10.4236 12.95 10.4209 12.7502C10.4209 12.5522 10.3416 12.3625 10.2006 12.2234C10.0597 12.0843 9.86889 12.0076 9.6709 12.0102V12.0002Z",
    fill: "#FFA500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6709 10.6303C9.25894 10.6249 8.92628 10.2922 8.9209 9.88027V6.78027C8.9209 6.36606 9.25668 6.03027 9.6709 6.03027C10.0851 6.03027 10.4209 6.36606 10.4209 6.78027V9.88027C10.4209 10.2945 10.0851 10.6303 9.6709 10.6303Z",
    fill: "#FFA500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.401d9362.svg";
export { ForwardRef as ReactComponent };